import React from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

/**
 * Confirms that adding or changing the bin will clear agent validation.
 */
export default function ValidatedBinChangeModal({
  open,
  onCancel,
  onConfirm,
  confirming = false,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/40"
        aria-label="Close dialog"
        onClick={onCancel}
      />
      <div className="relative z-10 w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
        <div className="flex items-start gap-3">
          <ExclamationTriangleIcon className="h-8 w-8 flex-shrink-0 text-amber-500" />
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Validated bin
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Your current bin has already been validated by an agent. Any
              change—including adding this material—will send the bin back to{" "}
              <span className="font-medium text-gray-800">
                pending validation
              </span>{" "}
              so an agent can review it again.
            </p>
          </div>
        </div>
        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            disabled={confirming}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={confirming}
            className="rounded-md bg-green-600 px-4 py-2 text-sm font-medium text-white hover:bg-green-700 disabled:opacity-50"
          >
            {confirming ? "Adding…" : "Continue and add"}
          </button>
        </div>
      </div>
    </div>
  );
}
